<template>
  <div class="error-container">
    <div class="error-box">
      <h3>An error occurred fetching this chart</h3>
      <v-icon x-large>sentiment_dissatisfied</v-icon>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ChartError"
  }
</script>

<style scoped>
  .error-container {
    display: flex;
    min-height: 400px;
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
  }

  .error-box {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
</style>
